<template>
    <div class="media-dialog item__preview" v-if="isVisible">
        <div class="media-dialog__header">
            <button @click="close" class="border-0 bg-transparent">
                <i class="fas fa-2x fa-times"></i>
            </button>
        </div>
        <div class="media-dialog__body">
            <video v-if="isVideo" controls>
                <source :src="source" :type="mimeType"/>
                Your browser doesn't support video, you may download the video <a :href="source">here</a>
            </video>
            <el-image v-else-if="isImage" fit="contain" :src="source"></el-image>
            <span v-else>Unsupported media, you may download it <a :href="source">here</a></span>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        source: null,
        mimeType: null,
      };
    },

    computed: {
      /**
       * @return {boolean}
       */
      isVisible() {
        return Boolean(this.source);
      },

      /**
       * @return {boolean}
       */
      isVideo() {
        return RegExp('^video\/(?!3gpp?)', 'i').test(this.mimeType);
      },

      /**
       * @return {boolean}
       */
      isImage() {
        return RegExp('^image\/', 'i').test(this.mimeType);
      },
    },

    methods: {
      /**
       * @param {Object} media
       */
      show(media) {
        this.source = _.get(media, 'url');
        this.mimeType = _.get(media, 'mimeType');
      },

      /**
       * @return {undefined}
       */
      close() {
        this.source = this.mimeType = null;
      },
    },

    created() {
      eventBus.$on('show-media-show-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-media-show-dialog', this.show);
    },
  }
</script>
